<template>
    <div>
        <div class="layout">
            <div class="cabinet-page_bg"></div>

            <HeaderAuth/>
            <div class="cabinet-content-block-wrapper">
                <div class="cabinet-content-block">

                    <ClientNavigation/>
                    <div class="cabinet-content">
                        <div class="heading-wrapper">
                            <div class="title">Мои отложенные письма</div>
                        </div>
                        <div class="cabinet-content-inner">

                            <div class="tabs-big tabs">
                                <div class="tabs-caption">
                                    <div class="tabs-caption-inner">
                                        <div @click="page = 'subs'" class="item" :class="{'active' : page === 'subs'}">Подписка оформлена</div>
                                        <div @click="page = 'drafts'" class="item" :class="{'active' : page === 'drafts'}">Черновики</div>
                                    </div>
                                </div>

                                <div v-if="!locked" class="tabs-content" :class="{'active' : page === 'subs'}">
                                    <MailsNoData v-if="subscribedMails.length === 0"/>
                                    <SubscribedMails v-else :subscribed-mails="subscribedMails"/>

                                </div>

                                <div v-if="!locked"  class="tabs-content" :class="{'active' : page === 'drafts'}">
                                    <EmptyDrafts v-if="drafts.length === 0"/>
                                    <Drafts v-else :drafts="drafts"/>

                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </div>
        <FooterAuth/>
    </div>
</template>


<script>

    import ClientNavigation from "../components/ClientNavigation";
    import FooterAuth from "../components/FooterAuth";
    import HeaderAuth from "../components/HeaderAuth";
    import MailsNoData from "../components/blocks/MailsNoData";
    import rest from "../restUtils";
    import SubscribedMails from "../components/blocks/SubscribedMails";
    import Drafts from "../components/blocks/Drafts";
    import EmptyDrafts from "../components/blocks/EmptyDrafts";

    export default {
        name: 'ClientMails',
        components: {
            EmptyDrafts,
            Drafts,
            SubscribedMails,
            MailsNoData,
            HeaderAuth,
            FooterAuth,
            ClientNavigation,
        },
        metaInfo: {
            title: 'Мои отложенные письма | Your Last Word'
        },

        data() {
            return {
                subscribedMails: [],
                drafts: [],
                page: 'subs',
                locked: false
            }
        },

        beforeCreate() {
            $('body').attr('class', 'cabinet-page');
        },

        async created() {

            if (this.$route.query.tab) {
                if (this.$route.query.tab === 'drafts') {
                    this.page = 'drafts';
                } else {
                    this.page = 'subs';
                }
            }

            this.locked = true;
            let mails = await rest.doGet('/mail');
            this.locked = false;
            mails.forEach(mail => {
                if (mail.subscribed) {
                    this.subscribedMails.push(mail);
                } else {
                    this.drafts.push(mail);
                }
            });

            let socialToken = this.$route.query.socialToken;
            if (!!socialToken) {
                let query = Object.assign({}, this.$route.query);
                delete query.socialToken;
                this.$router.replace({query});
                await this.$store.dispatch('changeLanguage', this.$ml.current);
            }
        }
    }

</script>

